/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Create
**********************************************************/
import { mapEmployeeForAutoComplete, onDummyComplete } from '../../utils';
import { AutoComplete, TextInput, DatePicker2 } from '../../components/inputs';
import EngineHours from './irrigation_engine_hours';
import MeterGallons from './irrigation_meter_gallons';
import ValveHours from './irrigation_valve_hours';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
const $ = window.$;

const propTypes = {
  employees: PropTypes.array,
  engines: PropTypes.array,
  meters: PropTypes.array,
  valves: PropTypes.array,
  user: PropTypes.object
};

class IrrigationForm extends Component {
  constructor(props) {
    super();
    this.calculateTotalMeterGallons = this.calculateTotalMeterGallons.bind(this);
  }
  componentDidMount() {
    $(document).ready(function(){
        $('#irr-tabs').tabs();
    });
  }
  calculateTotalMeterGallons({startGal, endGal, totalGalDOM}) {
    if (!(startGal && endGal)) return 0;
    if (Number(endGal) < Number(startGal)) return 0;
    totalGalDOM.value = Number((endGal - startGal).toFixed(2))
    if (Number(totalGalDOM.value) === 0) totalGalDOM.style.backgroundColor = '#ffffff';
    if (Number(totalGalDOM.value) > 0) {
      totalGalDOM.style.backgroundColor = '#bbdefb';
      totalGalDOM.style.fontWeight = 'bold';
      totalGalDOM.style.textAlign = 'center';
      totalGalDOM.style.color = '#424242';
    }
    return;
  }
  render() {
    return (
      <div>
        <div className="row">
          <form id={this.props.formId} onSubmit={(e) => e.preventDefault()}>
            <div className="col s12 m3 l3 xl3">
              <DatePicker2 id={'irrigation-date'} label={'Date'} max={moment().add(1, 'days').format('YYYY-MM-DD')} />
            </div>
            <div className="col s12 m3 l3 xl3">
              <AutoComplete id={'irrigation-employee'} label={'Employee'} data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={onDummyComplete} />
            </div>
            <div className="col s12 m6 l6 xl6">
              <TextInput id={'irrigation-notes'} label={'Notes'} />
            </div>
          </form>
          <div className="col s12">
            <ul id={'irr-tabs'} className="tabs">
              <li className="tab col s3">
                <a className="irr-tabs" href={'#irr-engines-meters'}>Engines & Meters</a>
              </li>
              <li className="tab col s3">
                <a className="irr-tabs" href={'#irr-valves'}>Valves</a>
              </li>
            </ul>
            <div id={'irr-engines-meters'}>
              <div className="row">
                <div className="col s12 m12 l12 xl3">
                  <form id={'engine-form'}>
                    <EngineHours engines={this.props.engines} handleEngineHours={this.props.handleEngineHours} edit={this.props.edit} />
                  </form>
                </div>
                <div className="col s12 m12 l12 xl9">
                  <form id={'meter-form'}>
                    <MeterGallons meters={this.props.meters} calculateTotalMeterGallons={this.calculateTotalMeterGallons} 
                      handleMeterGallons={this.props.handleMeterGallons} edit={this.props.edit} />
                  </form>
                </div>
              </div>
            </div>
            <div id={'irr-valves'}>
              <form id={'valve-form'}>
                <ValveHours valves={this.props.valves} handleValveHours={this.props.handleValveHours} edit={this.props.edit} />
              </form>  
            </div>
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}

IrrigationForm.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(IrrigationForm);



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/irrigation_form.js